import React from "react";
import PropTypes from "prop-types";
import Table from 'react-bootstrap/Table';

const styles = {
    tableData: {
        wordWrap: "break-word",
        minWidth: "160px",
        maxWidth: "160px"
    }
  };

class LocationList extends React.Component {
 
    render() {

        if (this.props.error) {
            return <div>Error: {this.props.error.message}</div>;
        } else if (!this.props.isLoaded) {
            return <div>Loading...</div>;
        } else {
            return (
                <Table striped bordered responsive hover size="sm">
                    <thead>
                        <tr>
                            <th>Location Name</th>
                            <th>Location Type</th>
                            <th>Date Added</th>
                        </tr>
                    </thead>

                    <tbody>
                        {this.props.locations.map(location => (
                            <tr key={location.id}>
                                <td style={styles.tableData} >{location.name}</td>
                                <td style={styles.tableData} >{location.type}</td>
                                <td>
                                    {(new Date(location.dateCreated)).toLocaleString()}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            );
        }
    }

}

LocationList.propTypes = {
    locations: PropTypes.array,
    error: PropTypes.object,
    isLoaded: PropTypes.bool
  };

export default LocationList;